export {
  MealboxPage as default,
  MealboxGetStaticPaths as getStaticPaths,
  MealboxGetStaticProps as getStaticProps,
} from "@chef/feature-week-editor";
